import { compareDates } from "./dateHelpers";
import { CompetitionWithId } from "../interfaces/ICompetitions";

export type SortDirection = "asc" | "desc";

/**
 * Sorts competitions by date
 * @param competitions - Array of competitions to sort
 * @param direction - Sort direction: "desc" (newest first) or "asc" (oldest first)
 */
export const sortCompetitionsByDate = (
  competitions: CompetitionWithId[],
  direction: SortDirection = "desc",
): CompetitionWithId[] => {
  const sorted = [...competitions].sort((a, b) => compareDates(a.date, b.date));
  return direction === "asc" ? sorted.reverse() : sorted;
};

/**
 * Filters competitions by search term
 * Searches in name, location, and date
 */
export const filterCompetitions = (
  competitions: CompetitionWithId[],
  searchTerm: string,
): CompetitionWithId[] => {
  if (!searchTerm.trim()) {
    return competitions;
  }

  const term = searchTerm.toLowerCase().trim();
  return competitions.filter(
    (comp) =>
      comp.name.toLowerCase().includes(term) ||
      comp.location?.toLowerCase().includes(term) ||
      comp.date?.toLowerCase().includes(term),
  );
};

/**
 * Filters and sorts competitions
 */
export const filterAndSortCompetitions = (
  competitions: CompetitionWithId[],
  searchTerm: string,
  sortDirection: SortDirection = "desc",
): CompetitionWithId[] => {
  const sorted = sortCompetitionsByDate(competitions, sortDirection);
  return filterCompetitions(sorted, searchTerm);
};
